import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '../../componentsv2/Typography';
import { COLORS } from '../../themev2';

type SuspenseBackdropProps = {
  isLoading?: boolean;
  componentRenderingIt?: string;
};

const SuspenseBackdrop = (props: SuspenseBackdropProps) => {
  const { isLoading = true, componentRenderingIt } = props;

  return (
    <div>
      <Backdrop
        open={isLoading}
        sx={{
          color: '#fff',
          zIndex: 999999,
          backgroundColor: '#F6FAFE',
        }}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
        >
          <CircularProgress size={50} sx={{ color: COLORS.green[600] }} />
          {process.env.NODE_ENV === 'development' && componentRenderingIt && (
            <Typography sx={{ fontWeight: 600, fontSize: '18px', lineHeight: '27px', color: '#4F5A84' }}>
              {componentRenderingIt}
            </Typography>
          )}
        </Box>
      </Backdrop>
    </div>
  );
};

export default SuspenseBackdrop;
